exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d-widget-content .d-calendar-event[data-v-5b95e415]{margin:.75rem .575rem 0;font-size:.875rem}", ""]);

// exports
